import EocDiagnosisCodesV1 from "../../../../components/form_builder/elements/eoc_diagnosis_codes/EocDiagnosisCodesV1.vue";

export default {
  componentName: "fb-eoc-diagnosis-codes-v1",
  component: EocDiagnosisCodesV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Patient Diagnosis Codes",
      description: "",
      eFormEditable: true,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
